/**
 * @file format
 * @author baoleilei
 */

export function formatArticle(data) {
  let article = {
    title: '',
    content: [],
    author: null,
    imgsList: []
  };
  if (data.title) {
    article.title = data.title;
    article.content = data.content.map(item => {
      switch (item.type) {
        case 'mthvideo':
          return {
            type: 'video',
            src: item.data.https.file,
            poster: item.data.https.cover,
            wh: item.data.video.heightInPixel / item.data.video.widthInPixel
          };
        case 'image':
          let info = item.data.big;
          let url = info.gifsrc ? info.gifsrc : info.url;
          article.imgsList.push(url);
          return {
            type: item.type,
            imageUrl: url,
            width: info.width,
            height: info.height
          };
        case 'text':
          // 标题可以特殊处理，其他目前不行。
          if (item.data_rtf && item.data_rtf.indexOf('bjh-h3') > -1) {
            return {
              type: 'sub-title',
              text: item.data
            };
          }
          return {
            type: item.type,
            text: item.data
          };
        default:
          return {
            type: item.type
          };
      }
    });
  }
  return article;
}